import { useSelector } from 'react-redux';
import { Box } from '@quintoandar-tokko/jopijs';
import styles from './visitsToConfirm.module.scss';
import { showCardSeparator } from '../utils';
import VisitsToConfirmCard from './VisitsToConfirmCard';

function VisitsToConfirmContainer({ trackCallback = null }) {
  const { visits } = useSelector(
    (state) => state.DashboardSlice.visitsToConfirm
  );

  return (
    <Box className={styles.visitsToConfirmContainer}>
      {visits.map((visit, index) => (
        <Box key={visit.id}>
          <VisitsToConfirmCard visit={visit} trackCallback={trackCallback} />
          {showCardSeparator(index, visits) && (
            <Box className={styles.separator} />
          )}
        </Box>
      ))}
    </Box>
  );
}

export default VisitsToConfirmContainer;
